import { produce } from 'immer';

/**
 * Instead of using spread operators i.e. - store.update(state => ({...state})),
 * we can guarantee immutability using ImmerJS
 * @see https://ngneat.github.io/elf/docs/immer
 * @param updater
 */
export function immutable<S>(updater: (state: S) => void): (state: S) => S {
  return (state) => {
    return produce(state, (draft) => {
      updater(draft as S);
    });
  };
}
